export default __webpack_public_path__ + "static/media/license-bottom-vector.aeff333a.png";